/**
 * en-GB messages added by Phase 1 task S6 (docs/PHASE-1-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const s6EnGB = {
    'nav.today': 'Today',
    'nav.today.desc': 'Who is on site now',
    'error.already_signed_out': 'This visit has already been signed out.',
    'error.already_signed_in': 'This person is already signed in at this site.',
    'error.visit_protected': 'This visit is protected, so it cannot be deleted. Remove the protection first.',
    'error.visit_times': 'The sign-in time must be before the sign-out time, and neither can be in the future.',
    'error.group_not_found': 'That group does not exist.',
    'error.group_not_on_kiosk': 'That group is not shown at this site.',
    'error.member_not_found': 'That person is not in this group.',
    'error.member_archived': 'That person has been archived, so they cannot sign in.',
    'error.full_name_required': 'Please enter a first and last name.',
    'error.qr_invalid': 'That badge code is not valid for this organisation.',
    'error.upload_exists': 'That upload id has already been used.',
    'error.module_not_enabled': 'That feature is not switched on.',
    'visit.event.merged': 'Merged with an earlier sign-in or sign-out; the earliest real event was kept.',
    'visit.event.superseded': 'Replaced by an earlier sign-out that arrived later.',
    'visit.event.validation_warning': 'Recorded as sent, but some answers or notices no longer match the current set-up.',
    'visit.event.waiting_sign_in': 'Waiting for the matching sign-in to arrive.',
    'visit.event.waiting_upload': 'Waiting for a photo or signature to arrive.',
    'visit.event.pending_expired': 'The matching sign-in or upload never arrived, so this event was dropped after 7 days.',
    'visit.event.other_site': 'That visit belongs to a different site.',
    'visit.event.visit_exists': 'A visit with that id already exists.',
    'visit.event.group_hidden': 'The group was no longer shown at this site when the event arrived.',
    'visit.event.too_old': 'The event is older than the allowed time, so it was not accepted.',
    'visit.event.in_future': 'The event is dated in the future (the kiosk clock may be wrong), so it was not accepted.',
    'visit.event.signed_out_by_system': 'Signed out automatically because the site or group changed.',
    'visit.event.signed_out_all': 'Signed out with "Sign everyone out".',
    'settings.visits': 'Visits',
    'settings.visits.retention': 'Keeping visit records',
    'settings.visits.retention.defaultVisitDays': 'Delete visits after this many days (0 = keep until deleted by hand)',
    'settings.visits.retention.visitDays': 'Delete visits after this many days (blank = the organisation default, 0 = keep)',
    'settings.visits.offline': 'Kiosks working offline',
    'settings.visits.offline.maxEventAgeDays': 'Refuse kiosk events queued for longer than this many days (0 = no limit)',
    'settings.visits.offline.clockSkewToleranceSeconds': 'Correct a kiosk clock that is out by more than this many seconds (0 = never correct)',
    'settings.visits.photo': 'Visitor photos',
    'settings.visits.photo.mode': 'Take a photo at sign-in',
    'settings.visits.photo.mode.never': 'Never',
    'settings.visits.photo.mode.always': 'Always',
    'settings.visits.photo.mode.chance': 'Some of the time',
    'settings.visits.photo.chancePercent': 'Chance of taking a photo (%)',
};
//# sourceMappingURL=s6.js.map